import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="main-footer">
        <strong>Copyright © 2014-2026 Way Almanac Engine​. </strong>
        All rights reserved.
      </footer>
    );
  }
}
